import { Card, Col, Row, Image, Button, Upload as UploadAntd, Form, message, Modal, Table, Input, DatePicker, Select } from "antd";
import React, { useEffect, useState, useForm } from "react";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import UploadIcon from "../assets/images/upload-icon.svg";
import ModalDeleteIcon from "../assets/images/delete-icon.svg";
import useRequest from "../hooks/useRequest";
import apiPath from "../constants/apiPath";
import EditTableIcon from "../assets/images/edit-icon-table.svg";
import { ShowToast, Severty } from "../helper/toast";
import { PlusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
const { TextArea } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;

const stripHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};
function Template() {
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [selectedContent, setSelectedContent] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [contactList, setContactList] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [text, setText] = useState("");


  const { request } = useRequest();


  const handleQuillChange = (e) => {
    console.log(e)
    setText(e);
    form.setFieldsValue({ description: e });
  };

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const fetchContent = () => {
    setLoading(true);
    request({
      url: apiPath.getTemplate,
      method: "GET",
      onSuccess: (data) => {
        if (data.status) {
          setDataSource(data.data.data)

          // const description = data.data.data[0].description || "";
          // const image = data.data.data[0].image || "";
          // setText(description);
          // setImage(image);
          // form.setFieldsValue({
          //   description: description,
          //   image: image
          // });
          // setFile([{
          //   url: image,
          // }]);
          // handleQuillChange(description)



        } else {
          message.error(data.message || "Failed to fetch content");
        }
        setLoading(false);
      },
      onError: (error) => {
        message.error(error?.message || "An error occurred while fetching content");
        setLoading(false);
      },
    });
  };



  useEffect(() => {
    fetchContactList()
    fetchContent();
  }, []);

  const handleSubmit = (values) => {
    const plainTextDescription = stripHtml(values.description);
    const payload = {
      ...values,
      description: plainTextDescription

    };
    request({
      url: apiPath.createTemplate,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        if (data.status) {
          handleOk()
          // message.success("Content updated successfully!");
          ShowToast("Data add successfully!", Severty.SUCCESS);
          fetchContent();

        } else {
          message.error(data.message || "Failed to update schedule");
        }
      },
      onError: (error) => {
        message.error(error?.message || "An error occurred while updating schedule");
      },
    });

  };


  const handleEditSubmit = (values) => {
    const plainTextDescription = stripHtml(values.description);
    const payload = {
      ...values,
      description: plainTextDescription

    };
    request({
      url: `${apiPath.editTemplate}/${selectedContent._id}`,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        if (data.status) {
          form1.resetFields();
          setEditOpen(false);
          // message.success("Content updated successfully!");
          ShowToast("Data updated successfully!", Severty.SUCCESS);
          fetchContent();

        } else {
          message.error(data.message || "Failed to update schedule");
        }
      },
      onError: (error) => {
        message.error(error?.message || "An error occurred while updating schedule");
      },
    });

  };


  const handleEditContent = (record) => {
    console.log(record, "record")
    if (!record || !record._id) {
      message.error("Invalid  record");
      return;
    }
    setSelectedContent(record);
    form1.setFieldsValue({
      title: record.title,
      description: record.description,

    });
    setEditOpen(true);
  };


  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const columns = [
    {
      title: "S.NO",
      dataIndex: "sno",
      key: "sno",
      width: 80,
      render: (text, record, index) => (
        <span className="sno">
          {((pagination.current - 1) * pagination.pageSize + index + 1)
            .toString()
            .padStart(2, "0")}
        </span>
      ),
    },

    {
      title: "Template Title",
      dataIndex: "title",
      key: "title",
      render: (title) => (
        <div>
          <p className="description">{title}</p>
        </div>
      ),
    },

    {
      title: "ACTION'S",
      key: "actions",
      width: 150,
      render: (record) => (
        <div className="actions">
          <Button
            className="edit-btn-table"
            icon={<img src={EditTableIcon} alt="Edit" />}
            onClick={() => handleEditContent(record)}
          />

        </div>
      ),
    },
  ];

  const fetchContactList = () => {
    request({
      url: `/common/contact-list`,
      method: "GET",
      onSuccess: (data) => {
        setContactList(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  return (
    <>
      <div className="page-top-space home-card layout-content">
        <div className="mb-24">
          <Row gutter={[24, 0]}>
            <Col xs={24} sm={24} md={24}>


              <Card bordered={false} className="card-main">

                <div className="upload-contant-card">
                  <div className="upload-card-header">
                    <div className="dashbord-headding-cont">
                      <h6>Template List</h6>
                      <Button type="primary" className="fill-btn" onClick={showModal}>
                        <PlusOutlined /> Add Template
                      </Button>
                    </div>

                    {/* <p>Lorem ipsum dolor sit amet consectetur. Duis cursus amet massa</p> */}
                    <div className="table-responsive">
                      <Table
                        dataSource={dataSource}
                        columns={columns}
                        loading={loading}
                        rowKey="id"
                        pagination={pagination}
                        onChange={handleTableChange}
                      />
                    </div>

                  </div>
                </div>

              </Card>

            </Col>
          </Row>
        </div>
      </div>
      <Modal
        title="Add Template"
        className="tab_modal"
        width={600}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Card bordered={false} className="card-main">
          <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <Form.Item
              name="title"
              label="Title"
              rules={[{ required: true, message: "Please enter a title" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              className="upload-contant-card"
              name="description"
              rules={[{ required: true, message: "Description is required" }]}
            >
              <ReactQuill value={text} onChange={(e) => handleQuillChange(e)} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" className="fill-btn" htmlType="submit">
                Create Template
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Modal>

      {/* Edit Question Modal */}
      <Modal
        title="Edit Template"
        className="tab_modal"
        width={900}
        open={editOpen}
        onCancel={() => {
          setEditOpen(false);
          form1.resetFields();
        }}
        footer={[false]}
      >
        <Card bordered={false} className="card-main">
          <Form form={form1} layout="vertical" onFinish={handleEditSubmit}>
            <Form.Item
              name="title"
              label="Title"
              rules={[{ required: true, message: "Please enter a title" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              className="upload-contant-card"
              name="description"
              rules={[{ required: true, message: "Description is required" }]}
            >
              <ReactQuill value={text} onChange={(e) => handleQuillChange(e)} />
            </Form.Item>



            <Form.Item>
              <Button type="primary" className="fill-btn" htmlType="submit">
                Update Template
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Modal>



    </>
  );
}

export default Template;
